import { Building2 } from 'lucide-react';

import { Button } from '@accio3d/design-system/button';
import { cn } from '@accio3d/design-system/utils';

import { useAuth } from '../../hooks/useAuth';

interface OrganizationSwitcherProps {
  collapsed?: boolean;
  onOpenModal?: () => void;
}

// Mirrors the portals' shared-ui OrganizationSwitcher: a footer button on the
// dark sidebar showing the current org, opening the org picker modal on click.
export function OrganizationSwitcher({
  collapsed = false,
  onOpenModal,
}: OrganizationSwitcherProps) {
  const { organization, availableOrganizations } = useAuth();
  if (availableOrganizations.length === 0) return null;

  return (
    <Button
      variant="ghost"
      onClick={onOpenModal}
      title={organization?.name ?? undefined}
      size={collapsed ? 'sm' : 'default'}
      className={cn(
        collapsed
          ? 'h-10 w-10 p-0'
          : 'flex w-full items-center justify-start gap-3 rounded-xl px-4 py-2.5',
        'text-white/80 hover:bg-white/10 hover:text-white',
      )}
    >
      <Building2 className="h-4 w-4 shrink-0" />
      {!collapsed && (
        <span className="truncate text-sm font-medium">
          {organization?.name || 'Select organization'}
        </span>
      )}
    </Button>
  );
}
